import Vue from 'vue'
import Router from 'vue-router'
import bindDetail from '@/components/wechat/bindDetail'
import bindPhone from '@/components/wechat/bindPhone'
import bindDetailnew from '@/components/wechat/bindDetailnew'
import bindPhonenew from '@/components/wechat/bindPhonenew'
import bindPhoneno from '@/components/wechat/bindPhoneno'
import platformnew from '@/components/wechat/platformnew'
import wexinPay from '@/components/wechat/wexinPay'

import ddbindDetail from '@/components/dd/ddbindDetail'
import ddbindPhone from '@/components/dd/ddbindPhone'
import ddhome from '@/components/dd/ddhome'
import ddwexinPay from '@/components/dd/ddwexinPay'

import dormitoryofficialHome from '@/components/dormitoryofficial/dormitoryofficialHome'
import deviceDetails from '@/components/dormitoryofficial/deviceDetails'
import chargingRecord from '@/components/dormitoryofficial/chargingRecord'
import chargingRecorduser from '@/components/dormitoryofficial/chargingRecorduser'
import chargeback from '@/components/dormitoryofficial/chargeback'

import featherhome from '@/components/featheradd/featherhome'
import featheruser from '@/components/featheradd/featheruser'
import featherhomeuser from '@/components/featheradd/featherhomeuser'
import featherusersuccess from '@/components/featheradd//featherusersuccess'

import scantest from '@/components/scantest'
Vue.use(Router)

export default new Router({
  base: '/leniaowx',  // 配置单页应用的基路径
  routes: [
    {
      path: '/',
      name: 'scantest',
      component: scantest
    },

    {
      path:'/chargeback',
      name:'chargeback',
      component: chargeback
    },
    {
      path:'/featheruser',
      name:'featheruser',
      component: featheruser
    },
    {
      path:'/featherhome',
      name:'featherhome',
      component: featherhome
    },
    {
      path:'/featherhomeuser',
      name:'featherhomeuser',
      component:featherhomeuser
    },
    {
      path:'/featherusersuccess',
      name:'featherusersuccess',
      component:featherusersuccess
    },
    {
      path:'/bindPhone',
      name:'bindPhone',
      component: bindPhone
    },
    {
      path:'/bindDetailnew',
      name:'bindDetailnew',
      component:bindDetailnew,
    },
    {
      path:'/bindPhonenew',
      name:'bindPhonenew',
      component:bindPhonenew
    },
    {
      path:'/platformnew',
      name:'platformnew',
      component:platformnew
    },
    {
      path:'/bindPhoneno',
      name:'bindPhoneno',
      component:bindPhoneno
    },

    {
      path:'/bindDetail',
      name:'bindDetail',
      component: bindDetail
    },
    {
      path:'/wexinPay',
      name:'wexinPay',
      component: wexinPay
    },
    {
      path:'/ddbindPhone',
      name:'ddbindPhone',
      component: ddbindPhone
    },
    {
      path:'/ddbindDetail',
      name:'ddbindDetail',
      component: ddbindDetail
    },
    {
      path:'/ddwexinPay',
      name:'ddwexinPay',
      component: ddwexinPay
    },
    {
      path:'/ddhome',
      name:'ddhome',
      component:ddhome
    },
    {
      path:'/dormitoryofficialHome',
      name:'dormitoryofficialHome',
      component:dormitoryofficialHome
    },
    {
      path:'/deviceDetails',
      mame:'deviceDetails',
      component:deviceDetails
    },
    {
      path:'/chargingRecord',
      mame:'chargingRecord',
      component:chargingRecord
    },
    {
      path:'/chargingRecorduser',
      mame:'chargingRecorduser',
      component:chargingRecorduser
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js